// extracted by mini-css-extract-plugin
module.exports = {"button":"buttonAngled-module--button--eKjjl","buttonReverse":"buttonAngled-module--buttonReverse--2XXM_"};